import styled from "styled-components";

export const DropdownStyle = styled.select`
  width: 100%;
  border-radius: 5px;
  padding: 5px;
  background-color: white;
`;
